type PhotoHeaderProps = {
  photos: (string | null)[];
};

const PhotoCell = ({ url }: { url: string | null }): React.JSX.Element => (
  <div className="tw:relative tw:min-h-0 tw:overflow-hidden tw:bg-white">
    {url && <img src={url} alt="" className="tw:absolute tw:inset-0 tw:size-full tw:object-cover" />}
  </div>
);

export const PhotoHeader = ({ photos }: PhotoHeaderProps): React.JSX.Element => (
  <div className="tw:grid tw:aspect-[7/2] tw:grid-cols-[5fr_3fr] tw:grid-rows-1 tw:gap-0.5 tw:bg-off-white">
    <PhotoCell url={photos[0] ?? null} />
    <div className="tw:grid tw:min-h-0 tw:grid-rows-2 tw:gap-0.5">
      <PhotoCell url={photos[1] ?? null} />
      <PhotoCell url={photos[2] ?? null} />
    </div>
  </div>
);
